module.exports = __webpack_public_path__ + "img/09 Aniamtion 3-squashed.c820aaca.jpg";